// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__3FhDJ","col":"styles_col__3C0Rg"};